<div class="custom-modal configuracao-produtos">
  <div class="header">
    <h1 mat-dialog-title>Configuração de Produtos</h1>
    <div>
      <mat-icon mat-dialog-close="cancel">close</mat-icon>
    </div>
  </div>
  <div mat-dialog-content>
    <form [formGroup]="filterForm">
      <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center" style="height: 170px">
        <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
      </div>
      <h3 class="mt-2" style="font-size: 14px;">CLIENTE</h3>
      {{clientes}}
      <br>
      <br>
      <h3 class="mt-2" style="font-size: 14px;">TODOS PRODUTOS</h3>
      <mat-slide-toggle (change)="selectAll()" formControlName="allProducts"
        matTooltip="Ao selecionar esta opção todos os produtos serão inclusos.">
      </mat-slide-toggle>
      <br>
      <br>
      <h3 [hidden]="allProducts == true" class="mt-2" style="font-size: 14px;">PRODUTOS</h3>

      <mat-form-field [hidden]="allProducts == true">
        <mat-select [disableControl]="allProducts" multiple #selectProduct formControlName="produtoSelecionado"
          disableOptionCentering="true" placeholder="Produtos">
          <mat-option><ngx-mat-select-search [formControl]="produtoMultiFilter" placeholderLabel="Buscar..."
          noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
          <div class="select-all">
            <mat-checkbox [(ngModel)]="allSelectProduct" color="primary" [ngModelOptions]="{standalone: true}"
              (change)="toggleAllSelectionProduct()">Selecionar todos</mat-checkbox>
          </div>
          <mat-option *ngFor="let produto of filteredProdutos | async" [value]="produto?.produtoID"
            (click)="optionClick()">
            {{ produto?.descricao }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
  <div class="modal-actions" mat-dialog-actions align="end">
    <button mat-flat-button color="primary" type="submit" (click)="closeProducts()">
      Salvar
    </button>
  </div>
